<template>
  <header id="header">
    <div class="left">
      <!-- <template v-if="$route.meta.game?.showPoints">
        <IconSpinner v-if="!isNumber(userStore.score)" style="margin-left: 8px;"/>
        <span v-else v-text="userStore.score"/>
        <IconStar/>
      </template> -->
    </div>

    <div class="right">
      <AppMenu 
        @reload-lobby="reloadHomePage"
        @logout="logout"
      />
    </div>
  </header>
</template>


<script>
import IconBurgerMenu from '@icons/IconBurgerMenu';
import IconSpinner from '@icons/IconSpinner';
import AppMenu from './AppMenu';
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  name: 'AppHeader',

  components: {
    IconBurgerMenu,
    IconSpinner,
    AppMenu,
  },

  computed: {
    ...mapState(['gameViewId']),
  },

  methods: {
    ...mapActions(['logout']),
    ...mapMutations(['setGameViewId']),
    reloadHomePage() {
      if (this.gameViewId !== 'lobby') this.setGameViewId('lobby');
    },
  },
};
</script>


<style lang="scss" scoped>
header {
  justify-content: space-between;
  position: relative;
  align-items: center;
  pointer-events: none;
  max-width: 1000px;
  margin: 0 auto;
  display: flex;
  height: 64px;
  z-index: 11;
  width: 100%;

  * svg {
    font-size: 24px;
  }

  .right {
    display: flex;
    align-items: center;
    pointer-events: all;
    position: relative;
    height: 40px;
    gap: 4px;
  }
}
</style>